import {Component} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {DecimalPipe} from '@angular/common';

@Component({
  selector: 'app-modal-table-alert',
  templateUrl: './modal-table-alert.component.html',
  styleUrls: []
})
export class ModalTableAlertComponent {
  id = '';
  texts = [];

  beloppUtbetald: '';
  datum: '';
  inkomsttyp: '';
  land: '';
  skatt: '';
  utlandskSkatt: '';
  valuta: '';

  constructor(
    public modalRef: BsModalRef,
    private readonly modalService: BsModalService,
    private readonly decimalPipe: DecimalPipe
  ) {
  }

  onConfirm(): void {
    this.modalService.setDismissReason(this.id + '-confirm');
    this.modalRef.hide();
  }

  onCancel(): void {
    this.modalService.setDismissReason(this.id + '-cancel');
    this.modalRef.hide();
  }

  convertToValuta(value: string, valuta: string): string {
    const decimal = +value;
    if (decimal <= 0) {
      return '';
    }

    const str = this.decimalPipe.transform(decimal, '0.0-2', 'se');
    return `${str} ${valuta}`;
  }
}
